import { render, staticRenderFns } from "./basicsAssembly.vue?vue&type=template&id=66bc4d6c&scoped=true&"
import script from "./basicsAssembly.vue?vue&type=script&lang=js&"
export * from "./basicsAssembly.vue?vue&type=script&lang=js&"
import style0 from "./basicsAssembly.vue?vue&type=style&index=0&id=66bc4d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bc4d6c",
  null
  
)

export default component.exports